import { ReactNode } from 'react'
import cx from 'classnames'
import styles from './DataTable.module.css'

/** 시안 `.tw`/`table` 이식. `align="right"` 열은 mono·우정렬·tabular-nums(`.num`), 그 외 `mono` 열은 `.code`. */
export type DataTableColumn = {
  key: string
  label: ReactNode
  align?: 'left' | 'right'
  mono?: boolean
}

export type DataTableRow = {
  key: string
  muted?: boolean
  selected?: boolean
  cells: Record<string, ReactNode>
}

export type DataTableProps = {
  columns: DataTableColumn[]
  rows: DataTableRow[]
  /**
   * 주면 표를 세로 스크롤 컨테이너에 넣는다(`.tw` 에 `max-height` + `overflow: auto`) — 100건까지
   * 받을 수 있는 결과 표가 끝없이 길어지는 것을 막는다. opt-in 이라 안 주면 기존 두 사용처
   * (`HoldRuleTable`, `TraceTab` 주문표)는 지금 모양 그대로다.
   */
  maxHeight?: number | string
  /**
   * 주면 헤더 행을 스크롤 컨테이너 위에 고정한다(`position: sticky; top: 0`). `maxHeight` 와 함께
   * 쓰는 걸 전제로 한다 — 스크롤 컨테이너가 없으면 고정할 대상도 없다.
   */
  stickyHeader?: boolean
}

export const DataTable = ({ columns, rows, maxHeight, stickyHeader }: DataTableProps): JSX.Element => (
  <div className={cx(styles.tw, maxHeight != null && styles.scroll)} style={maxHeight != null ? { maxHeight } : undefined}>
    {/*
     * 칸 눌림 방지 — `maxHeight` 를 준 경우에 한해 표 폭을 `max-content` 로 풀어(`.tableFixed`)
     * `nowrap` 칸(`.num`, F-OPT `.idCell`)이 필요한 만큼 차지하게 한다. 넘치면 `.tw` 가 가로
     * 스크롤을 만든다. `maxHeight` 없는 기존 두 사용처는 지금처럼 `width: 100%` 로 눌린 채 그대로다.
     */}
    <table className={cx(styles.table, maxHeight != null && styles.tableFixed)}>
      <thead className={cx(stickyHeader && styles.stickyHeader)}>
        <tr>
          {columns.map((column) => (
            <th key={column.key} className={cx(column.align === 'right' && styles.num)}>
              {column.label}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {rows.map((row) => (
          <tr key={row.key} className={cx(row.muted && styles.muted, row.selected && styles.on)}>
            {columns.map((column) => (
              <td
                key={column.key}
                className={cx(
                  column.align === 'right' && styles.num,
                  column.mono && column.align !== 'right' && styles.code,
                )}
              >
                {row.cells[column.key]}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
)
